import { createContext } from 'react';
import type {
  AuthResult,
  Grant,
  PermissionKey,
  RecursoDoPlano,
  SessionUser,
  TenantSummary,
} from '@levitas/contracts';

export interface EstadoSessao {
  carregando: boolean;
  usuario: SessionUser | null;
  igreja: TenantSummary | null;
  igrejas: TenantSummary[];
  permissoes: Grant[];
  /** O que o plano da igreja abre (seção 11.1). */
  recursos: Partial<Record<RecursoDoPlano, boolean>>;
}

export interface ValorSessao extends EstadoSessao {
  aplicar: (auth: AuthResult) => Promise<void>;
  trocarIgreja: (tenantId: string) => Promise<void>;
  /**
   * Adota um token de acesso de suporte e recarrega quem a sessão é agora.
   *
   * O token **não** vai para o disco: ele vive na memória e morre com a aba.
   * Um acesso a conta de terceiro guardado no navegador sobreviveria à janela
   * de trinta minutos que existe justamente para limitá-lo.
   */
  adotarAcessoDeSuporte: (accessToken: string, impersonationId?: string) => Promise<void>;
  sair: () => Promise<void>;
  /** Relê quem a sessão é agora — depois de mudar uma preferência, por exemplo. */
  recarregar: () => Promise<void>;
  pode: (permissao: PermissionKey, escopoId?: string | null) => boolean;
  /**
   * Tem a permissão em **algum** escopo. O infantil precisa disto: o professor
   * tem `child_health:read` no escopo da sala e o responsável no escopo dele,
   * e nenhum dos dois passaria por uma checagem de tenant.
   */
  podeEmAlgumEscopo: (permissao: PermissionKey) => boolean;
  /**
   * O plano da igreja abre este recurso?
   *
   * Enquanto a sessão carrega, responde `true`: esconder um menu e mostrá-lo um
   * instante depois pisca a tela na cara de quem está usando.
   */
  temRecurso: (recurso: RecursoDoPlano) => boolean;
}

export const ContextoSessao = createContext<ValorSessao | null>(null);
